module.exports = __webpack_public_path__ + "img/io.072c22fa.png";